import React from "react";
import { TablePagination } from "@mui/material";

const CustomPagination = ({
  totalItems,
  page,
  onPageChange,
  limit,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 8, 10, 25],
}) => {
  return (
    <TablePagination
      component="div"
      count={totalItems}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={limit}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      labelDisplayedRows={({ from, to, count }) =>
        `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
      }
    />
  );
};

export default CustomPagination;
